// https://fonts.google.com/
export const GOOGLE_WEB_FONTS = [
  'Acme',
  'Aldrich',
  'Alexandria',
  'Alfa Slab One',
  'Amatic SC',
  'Arbutus',
  'Audiowide',
  'Barlow Semi Condensed',
  'Bebas Neue',
  'Bokor',
  'Boogaloo',
  'Bungee Inline',
  'Bungee Shade',
  'Cabin Sketch',
  'Changa',
  'Chewy',
  'Comfortaa',
  'Covered By Your Grace',
  'Creepster',
  'Dancing Script',
  'Dangrek',
  'Days One',
  'Dhurjati',
  'Exo 2',
  'Fontdiner Swanky',
  'Freckle Face',
  'Galindo',
  'Gloria Hallelujah',
  'Iceberg',
  'Indie Flower',
  'Jolly Lodger',
  'Kaushan Script',
  'Kelly Slab',
  'Kenia',
  'Knewave',
  'Lacquer',
  'Lobster',
  'Nabla',
  'Nerko One',
  'New Rocker',
  'Nosifer',
  'Orbitron',
  'Passero One',
  'Permanent Marker',
  'Pirata One',
  'Play',
  'Press Start 2P',
  'Racing Sans One',
  'Righteous',
  'Rubik Distressed',
  'Rubik Wet Paint',
  'Russo One',
  'Saira Stencil One',
  'Sancreek',
  'Shadows Into Light',
  'Shojumaru',
  'Silkscreen',
  'Syne Mono',
  'Teko',
  'Ubuntu',
  'UnifrakturMaguntia',
  'ZCOOL KuaiLe',
  'Zen Dots',
];

export const LOGO_MAKER_EDITOR = {
  width: 545,
  height: 545,
  mobileWidth: 355,
  mobileHeight: 355,
};
